const menuFr = {
    "add_to_cart": "Ajouter au panier",
    "add_to_order": "Ajouter à la commande",
    "already_in_cart": "Déjà dans votre panier",
    "update_order_item": "Mettre à jour la commande",
    "delete_order_item": "Supprimer l'élément",
    "available_categories": "Catégories de menu",
    "search_menu_placeholder": "Rechercher dans le menu",
    "guides": {
        "scan_qr": "Scannez le code QR sur la table avec votre téléphone",
        "order": "Commandez les articles sélectionnés depuis votre téléphone",
        "pay": "Payez séparément ou en une seule fois depuis votre téléphone",
        "accept": "Continuer"
    },
    "index_image": "Image d'index",
    "menu_saved": "Menu enregistré",
    "new_category": "Nouvelle catégorie",
    "menu_editor": "Menu de l'éditeur",
    "new_item": "Article neuf",
    "menu": "Menu",
    "allergens": "Allergènes",
    "generate_qr": "Générer un code QR",
    "allergen_list": {
        "gluten": "Gluten",
        "crustaceans": "crustacés",
        "eggs": "Œufs",
        "fish": "Poisson",
        "peanuts": "cacahuètes",
        "soybeans": "Soja",
        "milk": "Lait",
        "nuts": "noix",
        "celery": "Céleri",
        "mustard": "Moutarde",
        "sesame": "Sésame",
        "sulphur_dioxide": "dioxyde de soufre",
        "lupin": "Lupin",
        "molluscs": "Mollusques",
        "vegan": "Végan"
    },
    "add_allergen": "Ajouter un allergène",
    "auto_translate": "Traduction du menu",
    "no_category_name": "Aucun nom de catégorie spécifié dans la langue actuelle",
    "no_item_name": "Aucun nom d'élément spécifié dans la langue actuelle",
    "category_and_items_language": "Langue des catégories et des articles",
    "auto_translate_title": "La traduction automatique des menus ne peut s'appliquer qu'aux catégories et aux éléments déjà enregistrés. Il est recommandé de renseigner la langue initiale.",
    "auto_translate_description": "Cette fonctionnalité utilise Google Traduction. Les traductions ne sont pas toujours exactes, il est donc conseillé de les vérifier.",
    "translate_from": "Traduire de",
    "translate_to": "À ces langues",
    "auto_translate_error_invalid_languages": "Langues non valides sélectionnées pour la traduction",
    "auto_translate_success": "Menu traduit avec succès",
    "auto_translate_error_permission": "Vous n'êtes pas autorisé à traduire le menu",
    "auto_translate_error_generic": "Une erreur inconnue s'est produite lors de la traduction.",
    "auto_translate_feature_not_available": "La traduction automatique des menus est uniquement disponible avec un abonnement PRO.",
    "change_subscription_plan": "Changer d'abonnement",
    "menu_headers": "En-têtes et pieds de page de menu",
    "menu_header_editor_title": "Les en-têtes et pieds de page de menu sont les textes qui apparaissent en haut et en bas de votre menu en ligne, et que vous pouvez librement spécifier.",
    "menu_header_feature_not_available": "La modification de l'en-tête et du pied de page du menu n'est possible qu'avec un abonnement PRO.",
    "menu_header": "En-tête du menu",
    "menu_header_placeholder": "Rédigez un court message de bienvenue ou mettez en avant une offre en cours.",
    "menu_footer": "Pied de menu",
    "menu_footer_placeholder": "Vous pouvez saisir des informations concernant les frais de service, les allergènes ou d'autres informations importantes.",
    "menu_header_save_success": "En-tête et pied de page du menu enregistrés avec succès",
    "menu_header_save_error": "Une erreur s'est produite lors de l'enregistrement de l'en-tête et du pied de page du menu.",
    "menu_header_permission_error": "Vous n'avez pas l'autorisation de modifier l'en-tête et le pied de page du menu.",
    "menu_header_generic_error": "Une erreur inconnue s'est produite lors du chargement de l'en-tête et du pied de page du menu.",
    "menu_import": "Importer le menu",
    "import_success": "La dernière importation a été effectuée avec succès.",
    "import_failed": "La dernière importation a échoué en raison d'une exportation côté serveur",
    "attached_document": "Document joint",
    "allowed_file_types": "Types de fichiers autorisés : .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Langue du document",
    "import_options_pro_helpertext": "Les options « Désactiver » et « Ajouter » ne sont disponibles qu'avec un abonnement PRO.",
    "import_option_helpertexts": {
        "replace": "Les catégories et les éléments du menu actuel seront supprimés et remplacés par le nouveau menu généré.",
        "deactivate": "Les catégories et éléments du menu actuel seront désactivés et le nouveau menu généré sera ajouté.",
        "add": "Le menu actuel restera inchangé, et les nouveaux éléments seront ajoutés à la suite du menu actuel."
    },
    "import_type": "Type d'importation",
    "import_options": {
        "replace": "Remplacer",
        "deactivate": "Désactiver",
        "add": "Ajouter"
    },
    "menu_import_tooltip": "Importez un fichier contenant le menu de votre restaurant ou fournissez un lien vers un site web affichant le menu. Dans les deux cas, assurez-vous que le menu soit disponible au format texte, car nous ne pouvons pas traiter les images. Une fois l'importation lancée, notre IA traitera automatiquement le fichier et créera le nouveau menu dans la langue sélectionnée. Si vous souhaitez traduire les plats dans plusieurs langues ultérieurement, utilisez la fonction « Traduction du menu » ! L'importation prend entre 5 et 10 minutes.",
    "menu_import_replace_warning": "La méthode d'importation sélectionnée supprimera le menu actuel et le remplacera par le nouveau. Veuillez vérifier que le fichier importé respecte le format et le contenu corrects, car cette opération est irréversible ! Si vous ne souhaitez pas supprimer le menu actuel, veuillez choisir une autre méthode d'importation.",
    "start_import": "Importer",
    "file_or_url_required": "Veuillez sélectionner un fichier ou fournir une URL de site web",
    "file_and_url_error": "Vous ne pouvez fournir qu'un fichier ou une URL, pas les deux.",
    "import_site_url": "URL du site Web",
    "import_in_progress": "Importation en cours",
    "import_duration": "Cela peut prendre quelques minutes",
    "listing_manager_info": {
        "summary": "Avec Mozrest, gérez facilement vos annonces et vos avis depuis une plateforme unique. Gagnez du temps, améliorez votre réputation en ligne et optimisez votre efficacité opérationnelle.",
        "bullet_1": "Mettez à jour instantanément vos annonces sur Tripadvisor, Apple Maps, Google, Facebook, Quandoo et Bing en un seul clic.",
        "bullet_2": "Recevez des notifications en temps réel lorsque vos horaires et votre disponibilité ne correspondent pas, évitant ainsi la déception des clients et les avis négatifs.",
        "bullet_3": "Vérifiez rapidement que votre fiche est complète et que tous les détails importants, comme les photos, les menus et les horaires, sont exacts et à jour.",
        "setup_button": "Configurer Mozrest",
        "pro_warning": "Cette fonctionnalité nécessite un abonnement PRO."
    },
    "listing_manager_tabs": {
        "Listing": "Inscription",
        "ListingAnalytics": "Analyse des annonces",
        "ReviewsPage": "Avis",
        "ReviewAnalytics": "Analyse des avis",
        "ReplyTemplates": "Modèles de réponse",
        "Notifications": "Notifications"
    },
    "review_manager_set_title": "Configurer le gestionnaire d'avis",
    "review_manager_set_description": "Veuillez nous fournir des informations sur votre entreprise afin que nous puissions créer vos paramètres de base.",
    "confirm_settings": "Confirmer les paramètres",
    "confirm_delete_item": "Supprimer l'article ?",
    "confirm_delete_category": "Supprimer la catégorie et tous ses articles ?",
    "reorder_disabled_search": "Réorganisation désactivée pendant la recherche",
};

export default menuFr;
